import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { Point } from './Point';

import { useStyles } from './styles';

const SITUATIONS = [
  {
    title: 'Search or explore companies',
    description: {
      text: 'Browse the catalog with ratings and reviews to assess payment reliability.',
    },
  },
  {
    title: 'Review payment behavior',
    description: {
      list: ['Speed to pay rating', 'Ease of doing business', 'Reasons for delays', 'Real supplier feedback'],
    },
  },
  {
    title: 'Contribute your experience',
    description: {
      text: 'Leave a review to:',
      list: ['Help other businesses', 'Unlock more profile views'],
    },
  },
  {
    title: 'Make informed decisions',
    description: {
      text: 'Avoid risky counterparties and protect your cash flow.',
    },
  },
];

export const HowItWorks = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Box mb={8}>
        <Typography className={classes.title}>How RIABU works</Typography>
      </Box>
      <Grid container spacing={6}>
        {SITUATIONS.map(({ title, description }, index) => (
          <Grid key={title} item xs={12} sm={4} xl={3}>
            <Point order={index + 1} title={title} description={description} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
